<template>
  <div class="flex min-h-screen" :style="{ '--sidenav-width': sideNavWidth }">
    <side-nav />
    <div class="contents pb-20">
      <slot />
      <div class="modal-wrapper"></div>
      <bs-notify />
    </div>
  </div>
</template>

<script lang="ts">
import { useMeStore } from "~/stores/me";
import { SIDE_NAV_WIDTH, useSideNavStore } from "~/stores/sideNav";
import { setSentryUserData } from "~/utils/sentry";

export default defineComponent({
  computed: {
    sideNavWidth(): string {
      return useSideNavStore().isCollapsed ? SIDE_NAV_WIDTH.collapsed : SIDE_NAV_WIDTH.expanded;
    },
  },
  async mounted() {
    const user = await this.$auth.getUser();
    const role = user?.["https://api.choosebase.jp/roles"][0] ?? "";
    const meStore = useMeStore();
    meStore.setRole({ role });
    setSentryUserData(this.$sentry, {
      sub: user?.sub || "unknown user",
    });
  },
});
</script>

<style scoped>
.contents {
  display: block;
  width: calc(100vw - var(--sidenav-width));

  /* サイドバーの開閉に合わせて本文幅も滑らかに変化させる */
  transition: width 200ms ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .contents {
    transition: none;
  }
}

.modal-wrapper {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
